module.exports = __webpack_public_path__ + "media/images/icon_blog02_24-24-498e581e9336c48772ee94f98f9ca3e2.png";